<div class="side-nav-body">
  <div class="nav-item-grouping">
    @for (navItem of viewModel.topHalfNavItems$ | push: 'immediate'; track navItem?.id) {
      <app-nav-item
        *rxIf="navItem | isDefaultNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async"
        (navItemClicked)="handleNavItemClickedSideEffects(navItem)" />
      <app-settings-nav-item
        *rxIf="navItem | isSettingsNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async"
        (navItemClicked)="handleNavItemClickedSideEffects(navItem)" />
      <app-products-nav-item
        *rxIf="navItem | isProductsNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async"
        (navItemClicked)="handleNavItemClickedSideEffects(navItem)" />
    }
  </div>
  <div class="nav-item-grouping">
    @for (navItem of viewModel.bottomHalfNavItems$ | push: 'immediate'; track navItem?.id) {
      <app-help-nav-item
        *rxIf="navItem | isHelpNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async" />
      <app-profile-nav-item
        *rxIf="navItem | isProfileNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async"
        (navItemClicked)="handleNavItemClickedSideEffects(navItem)" />
      <app-current-location-nav-item
        *rxIf="navItem | isLocationNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async" />
      <app-sign-out-nav-item
        *rxIf="navItem | isSignOutNavItem"
        [collapsed]="collapsed"
        [navItem]="navItem"
        [currentNavUrl]="viewModel.currentNavUrl$ | async" />
    }
  </div>
</div>
